/* eslint-disable no-unused-vars */
import { lazy } from 'react';
import CBadges from '../container/B2B/CompanyAdmin/Badges/CBadges';
import NewCDashboard from '../container/B2B/CompanyAdmin/Dashboard/NewCDashboard';
import AppIssues from '../container/APPIssues/AppIssues';
import PeapInvoice from '../container/Peap/components/Payment/PeapInvoice.jsx';
// import CSurveys from '../container/B2B/CompanyAdmin/Surveys/CSurveys';
import BTBAddNotification from '../container/PushNotification/BTBAddNotification';
import ViewNotification from '../container/ViewNotification';
import PartnerDashboard from '../container/Partnership/Dashboard/dashboard';
import IntroduceList from '../container/Partnership/IntroduceCompany/IntroCompany';
import IntroAddCompany from '../container/Partnership/IntroduceCompany/addCompany';
import EditIntroduce from '../container/B2B/B2BAdmin/Partnership/PartnerIntroduced/editIntroduce';
import PartnerEarning from '../container/Partnership/Earning/earning';
import Integrations from '../container/B2B/CompanyAdmin/Integrations/Integrations';
import ViewPartnerNotification from '../container/Partnership/Notification/Notification';
import PartnerLegals from '../container/Partnership/Legals/legals';
import Breathwork from '../container/ContentManagement/Breathwork/Breathwork';
import AddEditBreathwork from '../container/ContentManagement/Breathwork/AddEditBreathwork';
import PeapProfile from '../container/Peap-Dashboard/Peap-Profile/peapProfile';
import Specialist from '../container/Peap/components/Specialist';
import Peapclient from '../container/Peap-Dashboard/peap-clients/Peapclient';
import NotFound from '../container/404NotFound';
import PulseSurveyDashboard from '../container/PulseSurvey';
import WellbankInvoiceDetails from '../container/Peap/WellBank/PurchaseHistory/InvoiceDetails';
import WellpointsInvoiceDetails from '../container/Peap/B2BWellPoints/InvoiceDetails.jsx';
import GenerateInvoice from '../container/Peap/B2BWellPoints/GenerateInvoice.jsx';
import Mytemplatesviewall from '../container/PulseSurvey/Mytemplatesviewall';
import myTemplatesDrafts from '../container/PulseSurvey/myTemplatesDrafts';

import AddEditPulseSurvey from '../container/PulseSurvey/addSurvey/addSurvey';
import InsightsB2bSurvey from '../container/PulseSurvey/InsightsB2bSurvey';
import PreviewPulseSurveys from '../container/PulseSurvey/preview/preivewPulseSurvey';
import PulseSurvey from '../container/PulseSurvey/pulseSurveyList';
import AppFeedbacks from '../container/AppFeedbacks/AppFeedbacks';
import HealthVideos from '../container/HealthVideos/HealthVideos.js';
import AllHealthVideos from '../container/HealthVideos/AllHealthVideos.js';
import EditHealthVideos from '../container/HealthVideos/EditHealthVideos.js';
import AdminBenefits from '../container/Benefits/AdminBenefits.js';
import ViewSurveyApproval from '../container/ContentApproval/ViewSurveyApproval';
import UnderMaintenance from '../container/userMaintenance';
import AddEditSelfAssessment from '../container/self-assessment/AddEditSelfAssessment';
import SelfAssessmentDashboard from '../container/self-assessment/selfAssessmentDashboard';
import AllAssessment from '../container/self-assessment/AllAssessments';
import ViewAssessment from '../container/self-assessment/viewAssessement';
import BadgeDashboard from '../container/B2B/CompanyAdmin/TeamChallanges/ChallangesDashboard';
import ChallangesDashboard from '../container/B2B/CompanyAdmin/TeamChallanges/ChallangesDashboard';
import AddEditChallanges from '../container/B2B/CompanyAdmin/TeamChallanges/AddEditChallanges';
import AddEditRewards from '../container/B2B/CompanyAdmin/TeamChallanges/AddEditRewards';
import ViewAllChallanges from '../container/B2B/CompanyAdmin/TeamChallanges/ViewAllChallanges';
import ViewAllRewards from '../container/B2B/CompanyAdmin/TeamChallanges/ViewAllRewards';
import AddEditWeeklyChallanges from '../container/B2B/CompanyAdmin/TeamChallanges/AddEditWeeklyChallanges';
import AddEditGuidance from '../container/ContentManagement/Guidance/AddEditGuidance';
import Guidance from '../container/ContentManagement/Guidance/Guidance';
import Challenges from '../container/ChallengesAndTasks/challenges/Challenges.js';
import ViewChallenges from '../container/ChallengesAndTasks/challenges/ViewChallenges.js';
import NewChallenges from '../container/ChallengesAndTasks/challenges/NewChallenges.js';
import AddCustomBenefitsPage from '../container/Benefits/AddCustomBenefits.js';
import PeapManagement from '../container/PeapManagement/index.js';
import ShoorahTest from '../container/TestFeature/ShoorahTest.js';
import B2BPage from '../container/B2B/B2BPage.js';
import PartnersPage from '../container/B2B/B2BAdmin/Partnership/PartnersPage.js';
// import B2BWellPoints from '../container/Peap/components/B2BWellBank';
// import AddPOD from '../container/PodExperts/AddPOD';
const TutorialsPage = lazy(() => import('../container/Tutorials/TutorialsPage'));
const TutorialsEditViewPage = lazy(() => import('../container/Tutorials/TutorialsEditViewPage'));
const AddPOD = lazy(() => import('../container/PodExperts/AddPOD'));
const Login = lazy(() => import('../container/Login'));
const ForgotPassword = lazy(() => import('../container/ForgotPassword'));
const ResetPassword = lazy(() => import('../container/ResetPassword'));
const ChangePassword = lazy(() => import('../container/ChangePassword'));
const Dashboard = lazy(() => import('../container/Dashboard'));
const PodExperts = lazy(() => import('../container/PodExperts/PodExpertLists'));
const Notification = lazy(() => import('../container/Notification'));
const SubAdmin = lazy(() => import('../container/SubAdmin/SubAdmin'));
const AddEditSubAdmin = lazy(() => import('../container/SubAdmin/AddEditSubAdmin'));
const Users = lazy(() => import('../container/Users/Users'));
const ViewEditUser = lazy(() => import('../container/Users/ViewEditUser'));
const Focus = lazy(() => import('../container/ContentManagement/Focus/Focus'));
const FocusView = lazy(() => import('../container/ContentManagement/Focus/AddEditFocus'));
const AddEditFocus = lazy(() => import('../container/ContentManagement/Focus/AddEditFocus'));
const Meditation = lazy(() => import('../container/ContentManagement/Meditations/Meditations'));
const AddEditMeditation = lazy(() =>
  import('../container/ContentManagement/Meditations/AddEditMeditation')
);
const PushNotification = lazy(() => import('../container/PushNotification/PushNotification'));
const AddPushNotification = lazy(() => import('../container/PushNotification/AddNotification'));
const SuperAdminInstantSupport = lazy(() =>
  import('../container/SuperAdminInstantSupport/index.js')
);
const SuperAdminInstantSupportAddCompany = lazy(() =>
  import('../container/SuperAdminInstantSupport/AddCompany.js')
);
const SuperAdminInstantSupportB2C = lazy(() =>
  import('../container/SuperAdminInstantSupport/b2cInstantSupport.js')
);
const ContentApproval = lazy(() => import('../container/ContentApproval/ContentApproval'));
const ViewContentApproval = lazy(() => import('../container/ContentApproval/ViewContentApproval'));
const CMS = lazy(() => import('../container/CMS/CMS'));
const AddEditCMS = lazy(() => import('../container/CMS/AddEditCMS'));
const Earning = lazy(() => import('../container/Earning/Earning'));
const Affirmation = lazy(() => import('../container/ContentManagement/Affirmation/Affirmation'));
const AddEditAffirmation = lazy(() =>
  import('../container/ContentManagement/Affirmation/AddEditAffirmation')
);
const Gratitude = lazy(() => import('../container/ContentManagement/Gratitude/Gratitude'));
const AddEditGratitude = lazy(() =>
  import('../container/ContentManagement/Gratitude/AddEditGratitude')
);
const Rituals = lazy(() => import('../container/ContentManagement/Rituals/Rituals'));
const AddEditRituals = lazy(() => import('../container/ContentManagement/Rituals/AddEditRituals'));
const BedTimeStories = lazy(() =>
  import('../container/ContentManagement/BedTimeStories/BedTimeStories')
);
const Sounds = lazy(() => import('../container/ContentManagement/Sounds/Sounds'));
const AddEditSounds = lazy(() => import('../container/ContentManagement/Sounds/AddEditSounds'));

const Config = lazy(() => import('../container/Config/Config'));

const TopPicks = lazy(() => import('../container/ContentManagement/TopPicks/TopPicks'));
const AddEditTopPicks = lazy(() =>
  import('../container/ContentManagement/TopPicks/AddEditTopPicks')
);

const Manifestation = lazy(() =>
  import('../container/ContentManagement/Manifestation/Manifestation')
);
const AddEditManifestation = lazy(() =>
  import('../container/ContentManagement/Manifestation/AddEditManifestation')
);
// const Draft = lazy(() => import('../container/Draft/Draft'));
// const ViewDraft = lazy(() => import('../container/Draft/ViewDraft'));
const ShoorahPods = lazy(() => import('../container/ContentManagement/ShoorahPods/ShoorahPods'));
const AddEditShoorhPods = lazy(() =>
  import('../container/ContentManagement/ShoorahPods/AddEditShoorahPods')
);
const B2BDashboard = lazy(() => import('../container/B2B/B2BAdmin/B2BDashboard/BTBDashboard'));
const B2BCompanylist = lazy(() => import('../container/B2B/B2BAdmin/CompanyList/Companylist'));
const AddCompany = lazy(() => import('../container/B2B/B2BAdmin/CompanyList/AddCompany'));
const B2BEarning = lazy(() => import('../container/B2B/B2BAdmin/Earnings/BTBEarning'));
const ViewCompany = lazy(() => import('../container/B2B/B2BAdmin/CompanyList/ViewCompany'));
const MyCompany = lazy(() => import('../container/B2B/CompanyAdmin/MyCompany/MyCompany'));
const CompanyUser = lazy(() => import('../container/B2B/CompanyAdmin/CUsers/CUser'));
const CompanyReport = lazy(() => import('../container/B2B/CompanyAdmin/Reports/CReports'));
const CompanySolution = lazy(() => import('../container/B2B/CompanyAdmin/Solution/CSolution'));
const AddUser = lazy(() => import('../container/B2B/CompanyAdmin/CUsers/AddUser'));

const PartnerList = lazy(() => import('../container/B2B/B2BAdmin/Partnership/Partners/partner'));
const B2cUsers = lazy(() => import('../container/B2B/B2BAdmin/Badges/b2cUsers.js'));
const B2bUsers = lazy(() => import('../container/B2B/B2BAdmin/Badges/b2bUsers.js'));
const ActiveBadges = lazy(() => import('../container/B2B/B2BAdmin/Badges/activeBadges.js'));
const AddBadges = lazy(() => import('../container/B2B/B2BAdmin/Badges/addBadges.js'));
const PreviewTask = lazy(() =>
  import('../container/B2B/B2BAdmin/Badges/Components/PreviewTask.js')
);
const ViewB2BDetails = lazy(() =>
  import('../container/B2B/B2BAdmin/Badges/Components/viewB2BDetails.js')
);

const PartnerIntroduced = lazy(() =>
  import('../container/B2B/B2BAdmin/Partnership/PartnerIntroduced/partnerIntroduced')
);

const PartnerAdd = lazy(() => import('../container/B2B/B2BAdmin/Partnership/Partners/addPartner'));

const MyAccount = lazy(() => import('../container/Partnership/Account/myaccount'));

// Survey imports
const AddEditSurvey = lazy(() => import('../container/Survey/AddEditSurvey'));
const PreviewSurvey = lazy(() => import('../container/Survey/PreviewSurvey'));
const MySurvey = lazy(() => import('../container/PulseSurvey/MyPulseSurvey'));
const SurveyDashboard = lazy(() => import('../container/Survey/SurveyDashboard'));
const SurveyStatistics = lazy(() => import('../container/Survey/SurveyStatistics'));

// Vision imports
const VisionIdeas = lazy(() => import('../container/ContentManagement/VisionIdeas/VisionIdeas'));
const AddEditVisionIdeas = lazy(() =>
  import('../container/ContentManagement/VisionIdeas/AddEditVisionIdeas')
);
//peap imports
const MySpecialistProfile = lazy(() =>
  import('../container/Peap/mySpecialistProfile/mySpecialistProfile')
);

const PeapDashboard = lazy(() => import('../container/Peap/components/PeapDashboard'));
const Tasks = lazy(() => import('../container/ChallengesAndTasks/tasks/Tasks.js'));
const ViewAllTasks = lazy(() => import('../container/ChallengesAndTasks/tasks/ViewAllTasks.js'));
const CreateTask = lazy(() => import('../container/ChallengesAndTasks/tasks/AddTasks.js'));

const MarketPlace = lazy(() => import('../container/MarketPlace/index.js'));
const MarketPlaceNewOffering = lazy(() => import('../container/MarketPlace/CreateNewOffering.js'));
const MarketPlaceViewCompanies = lazy(() => import('../container/MarketPlace/ViewCompanies.js'));
const MarketPlaceViewOffers = lazy(() => import('../container/MarketPlace/ViewOffers.js'));
const MarketPlaceCreateNewCompanyOffer = lazy(() =>
  import('../container/MarketPlace/CreateNewCompanyOffer.js')
);

const TestLandingPage = lazy(() => import('../container/TestFeature/index.js'));
const CreateTestPage = lazy(() => import('../container/TestFeature/CreateTest.js'));
const ViewTestsPage = lazy(() => import('../container/TestFeature/viewTests.js'));
const TestsB2BCompaniesPage = lazy(() => import('../container/TestFeature/B2bcompaniesTable.js'));
const B2BTestCompaniesTable = lazy(() =>
  import('../container/TestFeature/B2BCompanyTestResults.js')
);

// B2B WellPoints
const B2BWellPoints = lazy(() => import('../container/Peap/B2BWellPoints/B2BWellPoints'));
const SuperAdminTestFeature = lazy(() => import('../container/SuperAdminTestFeature/index.js'));

// Soorah Health imports
const SoorahHealth = lazy(() => import('../container/SoorahHealth'));
const WorkoutListing = lazy(() => import('../container/SoorahHealth/Workout/WorkoutListing'));
const WorkoutDetail = lazy(() => import('../container/SoorahHealth/Workout/WorkoutDetail'));
const AddWorkout = lazy(() => import('../container/SoorahHealth/Workout/AddWorkout'));
const WorkoutPlanListing = lazy(() =>
  import('../container/SoorahHealth/WorkoutPlan/WorkoutPlanListing')
);
const WorkoutPlanDetail = lazy(() =>
  import('../container/SoorahHealth/WorkoutPlan/WorkoutPlanDetail')
);
const AddWorkoutPlan = lazy(() => import('../container/SoorahHealth/WorkoutPlan/AddWorkoutPlan'));
const RecipeListing = lazy(() => import('../container/SoorahHealth/Recipe/RecipeListing'));
const RecipeDetail = lazy(() => import('../container/SoorahHealth/Recipe/RecipeDetail'));
const AddRecipe = lazy(() => import('../container/SoorahHealth/Recipe/AddRecipe'));

const routes = [
  {
    path: '/login',
    exact: true,
    name: 'Login',
    component: Login,
    private: false
  },
  {
    path: '/forgot-password',
    exact: true,
    name: 'ForgotPassword',
    component: ForgotPassword,
    private: false
  },
  {
    path: '/reset-password',
    exact: true,
    name: 'ResetPassword',
    component: ResetPassword,
    private: false
  },
  {
    path: '/change-password',
    exact: true,
    name: 'ChangePassword',
    component: ChangePassword,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/podExperts',
    exact: true,
    name: 'Experts',
    component: PodExperts,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/podExperts/addPodExperts',
    exact: true,
    name: 'Add Experts',
    component: AddPOD,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/podExperts/editPodExperts/:id',
    exact: true,
    name: 'Edit Experts',
    component: AddPOD,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/dashboard',
    exact: true,
    name: 'Dashboard',
    component: Dashboard,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/notifications',
    exact: true,
    name: 'Notification',
    // component: Notification,
    component: ViewNotification,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/sub-admins',
    exact: true,
    name: 'SubAdmin',
    component: SubAdmin,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  {
    path: '/sub-admins/add-edit',
    exact: true,
    name: 'AddEditSubAdmin',
    component: AddEditSubAdmin,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  {
    path: '/users',
    exact: true,
    name: 'Users',
    component: Users,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/users/view',
    exact: true,
    name: 'ViewEditUser',
    component: ViewEditUser,
    private: true,
    onlyCompanyAdmin: true,
    onlyAdmin: false
  },
  {
    path: '/users/edit',
    exact: true,
    name: 'ViewEditUser',
    component: ViewEditUser,
    private: true,
    onlyCompanyAdmin: true,
    onlyAdmin: false
  },
  {
    path: '/challenges',
    exact: true,
    name: 'Challenges',
    component: UnderMaintenance,
    // component: Challenges,
    private: true,
    onlyCompanyAdmin: true,
    onlyAdmin: false
  },
  {
    path: '/tasks',
    exact: true,
    name: 'Tasks',
    component: UnderMaintenance,
    //component: Tasks,
    private: true,
    onlyCompanyAdmin: true,
    onlyAdmin: false
  },
  {
    path: '/tasks/view-all-tasks',
    exact: true,
    name: 'Tasks',
    component: ViewAllTasks,
    private: true,
    onlyCompanyAdmin: true,
    onlyAdmin: false
  },
  {
    path: '/tasks/create-task',
    exact: true,
    name: 'Tasks',
    component: CreateTask,
    private: true,
    onlyCompanyAdmin: true,
    onlyAdmin: false
  },
  {
    path: '/challenges/view-challenges',
    exact: true,
    name: 'Challenges',
    component: ViewChallenges,
    private: true,
    onlyCompanyAdmin: true,
    onlyAdmin: false
  },
  {
    path: '/challenges/create-new-challenges',
    exact: true,
    name: 'Challenges',
    component: NewChallenges,
    private: true,
    onlyCompanyAdmin: true,
    onlyAdmin: false
  },
  {
    path: '/content-management/focus',
    exact: true,
    name: 'Focus',
    component: Focus,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/content-management/focus/view',
    exact: true,
    name: 'Focus-view',
    component: FocusView,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/content-management/focus/add-edit',
    exact: true,
    name: 'AddEditFocus',
    component: AddEditFocus,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/content-management/meditation',
    exact: true,
    name: 'Meditation',
    component: Meditation,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/content-management/meditation/add-edit',
    exact: true,
    name: 'AddEditMeditation',
    component: AddEditMeditation,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/content-management/meditation/view',
    exact: true,
    name: 'ViewAffirmation',
    component: AddEditMeditation,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/content-management/breathwork',
    exact: true,
    name: 'Breathwork',
    component: Breathwork,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/content-management/breathwork/add-edit',
    exact: true,
    name: 'AddEditBreathwork',
    component: AddEditBreathwork,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/content-management/breathwork/view',
    exact: true,
    name: 'ViewBreathwork',
    component: AddEditBreathwork,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/content-management/health',
    exact: true,
    name: 'Guidance',
    component: Guidance,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/content-management/health/add-edit',
    exact: true,
    name: 'AddEditGuidance',
    component: AddEditGuidance,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/content-management/health/view',
    exact: true,
    name: 'ViewGuidance',
    component: AddEditGuidance,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/content-management/affirmation',
    exact: true,
    name: 'Affirmation',
    component: Affirmation,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/content-management/affirmation/add-edit',
    exact: true,
    name: 'AddEditAffirmation',
    component: AddEditAffirmation,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/content-management/affirmation/view',
    exact: true,
    name: 'AddEditAffirmation',
    component: AddEditAffirmation,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/content-management/gratitude',
    exact: true,
    name: 'Gratitude',
    component: Gratitude,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/content-management/gratitude/add-edit',
    exact: true,
    name: 'AddEditGratitude',
    component: AddEditGratitude,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/content-management/rituals',
    exact: true,
    name: 'Rituals',
    component: Rituals,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/content-management/rituals/view',
    exact: true,
    name: 'ViewRituals',
    component: AddEditRituals,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/content-management/rituals/add-edit',
    exact: true,
    name: 'AddEditRituals',
    component: AddEditRituals,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/content-management/bedtime-stories',
    exact: true,
    name: 'BedTimeStories',
    component: BedTimeStories,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/content-management/sounds',
    exact: true,
    name: 'Sounds',
    component: Sounds,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/content-management/sounds/view',
    exact: true,
    name: 'ViewSound',
    component: AddEditSounds,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/content-management/sounds/add-edit',
    exact: true,
    name: 'Sounds',
    component: AddEditSounds,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/content-management/top-picks',
    exact: true,
    name: 'TopPicks',
    component: TopPicks,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/content-management/top-picks/add-edit',
    exact: true,
    name: 'TopPicks',
    component: AddEditTopPicks,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/content-management/manifestation',
    exact: true,
    name: 'Manifestation',
    component: Manifestation,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/content-management/manifestation/add-edit',
    exact: true,
    name: 'AddEditManifestation',
    component: AddEditManifestation,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/push-notification',
    exact: true,
    name: 'PushNotification',
    component: PushNotification,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/push-notification/add',
    exact: true,
    name: 'AddPushNotification',
    component: AddPushNotification,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  // Instant Support and its pages

  {
    path: '/instant-support/b2b',
    exact: true,
    name: 'InstantSupport',
    component: SuperAdminInstantSupport,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  {
    path: '/instant-support/b2b/add-company',
    exact: true,
    name: 'InstantSupport',
    component: SuperAdminInstantSupportAddCompany,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  {
    path: '/instant-support/b2b/add-company',
    exact: true,
    name: 'InstantSupport',
    component: SuperAdminInstantSupportAddCompany,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  {
    path: '/instant-support/b2c',
    exact: true,
    name: 'InstantSupport',
    component: UnderMaintenance,
    // component: SuperAdminInstantSupportB2C,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },

  // Test Feature pages and their routes
  {
    path: '/test/b2c',
    exact: true,
    name: 'Shoorah Test',
    component: TestLandingPage,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  // MarketPlace pages and their routes
  {
    path: '/marketplace',
    exact: true,
    name: 'Marketplace',
    component: MarketPlace,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  {
    path: '/marketplace/create-new-offering',
    exact: true,
    name: 'Marketplace New Offering',
    component: MarketPlaceNewOffering,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  {
    path: '/marketplace/view-companies',
    exact: true,
    name: 'Marketplace View Companies',
    component: MarketPlaceViewCompanies,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  {
    path: '/marketplace/view-offers',
    exact: true,
    name: 'Marketplace View Offers',
    component: MarketPlaceViewOffers,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  {
    path: '/marketplace/create-new-company-offer',
    exact: true,
    name: 'Marketplace Create New Company',
    component: MarketPlaceCreateNewCompanyOffer,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  {
    path: '/test/tests-dashboard/create-test',
    exact: true,
    name: 'Create Test',
    // component: UnderMaintenance,
    component: CreateTestPage,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  {
    path: '/test/tests-dashboard',
    exact: true,
    name: 'View Tests',
    // component: UnderMaintenance,
    // component: ViewTestsPage,
    component: ShoorahTest,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  {
    path: '/test/b2b',
    exact: true,
    name: 'B2B Companies Tests',
    // component: UnderMaintenance,
    component: TestsB2BCompaniesPage,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  {
    path: '/test/b2b/b2b-company',
    exact: true,
    name: 'B2B Company Test Results',
    // component: UnderMaintenance,
    component: B2BTestCompaniesTable,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },

  // MarketPlace pages and their routes
  {
    path: '/marketplace',
    exact: true,
    name: 'Marketplace',
    component: MarketPlace,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  {
    path: '/marketplace/create-new-offering',
    exact: true,
    name: 'Marketplace New Offering',
    component: MarketPlaceNewOffering,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  {
    path: '/marketplace/view-companies',
    exact: true,
    name: 'Marketplace View Companies',
    component: MarketPlaceViewCompanies,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  {
    path: '/marketplace/view-offers',
    exact: true,
    name: 'Marketplace View Offers',
    component: MarketPlaceViewOffers,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  {
    path: '/marketplace/create-new-company-offer',
    exact: true,
    name: 'Marketplace Create New Company',
    component: MarketPlaceCreateNewCompanyOffer,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  {
    path: '/content-approval',
    exact: true,
    name: 'ContentApproval',
    component: ContentApproval,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  {
    path: '/content-approval/view',
    exact: true,
    name: 'view-content-approval',
    component: ViewContentApproval,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  {
    path: '/view-survey/:surveyId',
    exact: true,
    name: 'view-view-survey',
    component: ViewSurveyApproval,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  {
    path: '/cms',
    exact: true,
    name: 'cms',
    component: CMS,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/cms/edit-view',
    exact: true,
    name: 'AddEditCMS',
    component: AddEditCMS,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/earning',
    exact: true,
    name: 'Earning',
    component: Earning,
    private: true,
    onlyCompanyAdmin: false
  },
  {
    path: '/config',
    exact: true,
    name: 'config',
    component: Config,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  // {
  //   path: '/draft',
  //   exact: true,
  //   name: 'draft',
  //   component: Draft,
  //   private: true,
  // onlyCompanyAdmin:false,
  //   onlyAdmin: false,
  // },
  // {
  //   path: '/draft/view',
  //   exact: true,
  //   name: 'ViewDraft',
  //   component: ViewDraft,
  //   private: true,
  // onlyCompanyAdmin:false,
  //   onlyAdmin: false,
  // },
  {
    path: '/content-management/shoorah-pods',
    exact: true,
    name: 'ShoorahPods',
    component: ShoorahPods,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/content-management/shoorah-pods/view',
    exact: true,
    name: 'ViewShoorahPods',
    component: AddEditShoorhPods,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/app-issues',
    exact: true,
    name: 'appIssues',
    component: AppIssues,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  {
    path: '/app-feedbacks',
    exact: true,
    name: 'appFeedbacks',
    component: AppFeedbacks,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  {
    path: '/benefits',
    exact: true,
    name: 'Benefits',
    component: UnderMaintenance,
    // component: AdminBenefits,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '//benefits/add-custom-benefits',
    exact: true,
    name: 'Add Custom Benefits',
    component: AddCustomBenefitsPage,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/health-videos',
    exact: true,
    name: 'healthVideos',
    component: HealthVideos,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/health-videos/all',
    exact: true,
    name: 'allHealthVideos',
    component: AllHealthVideos,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/health-videos/add-edit',
    exact: true,
    name: 'addHealthVideos',
    component: EditHealthVideos,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  {
    path: '/content-management/shoorah-pods/add-edit',
    exact: true,
    name: 'AddEditShoorahPods',
    component: AddEditShoorhPods,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },

  {
    path: '/b2c-users',
    exact: true,
    name: 'Badges & Wellpoints',
    component: B2cUsers,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/active-badges',
    exact: true,
    name: 'Acive Badges',
    component: ActiveBadges,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/active-badges/add-badge',
    exact: true,
    name: 'Acive Badges / Badge',
    component: AddBadges,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/active-badges/preview',
    exact: true,
    name: 'Acive Badges / Badges',
    component: PreviewTask,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/b2b-users',
    exact: true,
    name: 'Badges',
    component: B2bUsers,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/b2b-users/:id',
    exact: true,
    name: 'Badges',
    component: ViewB2BDetails,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/partners',
    exact: true,
    name: 'Partner-list',
    // component: PartnerList,
    component: PartnersPage,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/partner-introduced',
    exact: true,
    name: 'Partners-company-introduced',
    component: PartnerIntroduced,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/partners-introduce/edit-introduce',
    exact: true,
    name: 'Edit-company-introduced',
    component: EditIntroduce,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/partners/add-partner',
    exact: true,
    name: 'Partners-add-partner',
    component: PartnerAdd,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/partner-earning',
    exact: true,
    name: 'Partner Earning',
    component: PartnerEarning,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/partner-notification',
    exact: true,
    name: 'Partner Notifications',
    component: ViewPartnerNotification,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/B2B-dashboard',
    exact: true,
    name: 'B2BDashboard',
    // component: B2BDashboard,
    component: B2BPage,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/B2B-company-list',
    exact: true,
    name: 'B2BCompanylist',
    component: B2BCompanylist,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/B2B-earning',
    exact: true,
    name: 'B2BEarning',
    component: B2BEarning,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/B2B-company-list/addCompany',
    exact: true,
    name: 'AddCompany',
    component: AddCompany,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/B2B-company-list/viewCompany',
    exact: true,
    name: 'ViewCompany',
    component: ViewCompany,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/partner-dashboard',
    exact: true,
    name: 'PartnerDashboard',
    // TODO: Switch
    // component: CompanyDashboard,
    component: PartnerDashboard,
    private: true,
    onlyCompanyAdmin: false,
    onlyPartner: true,
    onlyAdmin: false
  },
  {
    path: '/partner-account',
    exact: true,
    name: 'PartnerAccount',
    // TODO: Switch
    // component: CompanyDashboard,
    component: MyAccount,
    private: true,
    onlyCompanyAdmin: false,
    onlyPartner: true,
    onlyAdmin: false
  },
  {
    path: '/introduce',
    exact: true,
    name: 'IntroduceCompany',
    // TODO: Switch
    // component: CompanyDashboard,
    component: IntroduceList,
    private: true,
    onlyCompanyAdmin: false,
    onlyPartner: true,
    onlyAdmin: false
  },
  {
    path: '/introduce/add-company',
    exact: true,
    name: 'IntroduceAddCompany',
    // TODO: Switch
    // component: CompanyDashboard,
    component: IntroAddCompany,
    private: true,
    onlyCompanyAdmin: false,
    onlyPartner: true,
    onlyAdmin: false
  },
  {
    path: '/partner-legals',
    exact: true,
    name: 'Legals',
    // TODO: Switch
    // component: CompanyDashboard,
    component: PartnerLegals,
    private: true,
    onlyCompanyAdmin: false,
    onlyPartner: true,
    onlyAdmin: false
  },
  {
    path: '/:slug/dashboard',
    exact: true,
    name: 'CompanyDashboard',
    // TODO: Switch
    // component: CompanyDashboard,
    component: NewCDashboard,
    private: true,
    onlyCompanyAdmin: true,
    onlyAdmin: false
  },
  {
    path: '/:slug/myCompany',
    exact: true,
    name: 'MyCompany',
    component: MyCompany,
    private: true,
    onlyCompanyAdmin: true,
    onlyAdmin: false
  },
  {
    path: '/:slug/notification',
    exact: true,
    name: 'CompanyNotification',
    component: Notification,
    private: true,
    onlyCompanyAdmin: true,
    onlyAdmin: false
  },

  {
    path: '/:slug/notification/add',
    exact: true,
    name: 'BTBAddPushNotification',
    component: BTBAddNotification,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/:slug/report',
    exact: true,
    name: 'CompanyReport',
    component: CompanyReport,
    private: true,
    onlyCompanyAdmin: true,
    onlyAdmin: false
  },
  {
    path: '/:slug/badges',
    exact: true,
    name: 'CompanyReport',
    component: CBadges,
    private: true,
    onlyCompanyAdmin: true,
    onlyAdmin: false
  },
  {
    path: '/team-challanges',
    exact: true,
    name: 'TeamChallanges',
    component: ChallangesDashboard,
    private: true,
    onlyCompanyAdmin: true,
    onlyAdmin: true
  },
  {
    path: '/team-challanges/view-all-rewards',
    exact: true,
    name: 'TeamChallanges',
    component: ViewAllRewards,
    private: true,
    onlyCompanyAdmin: true,
    onlyAdmin: true
  },
  {
    path: '/team-challanges/view-all-challenges',
    exact: true,
    name: 'TeamChallanges',
    component: ViewAllChallanges,
    private: true,
    onlyCompanyAdmin: true,
    onlyAdmin: true
  },
  {
    path: '/team-challanges/add-edit-challenges',
    exact: true,
    name: 'TeamChallanges',
    component: AddEditChallanges,
    private: true,
    onlyCompanyAdmin: true,
    onlyAdmin: true
  },
  {
    path: '/team-challanges/add-edit-weekly-challenges',
    exact: true,
    name: 'TeamChallanges',
    component: AddEditWeeklyChallanges,
    private: true,
    onlyCompanyAdmin: true,
    onlyAdmin: true
  },
  {
    path: '/team-challanges/add-edit-rewards',
    exact: true,
    name: 'TeamChallanges',
    component: AddEditRewards,
    private: true,
    onlyCompanyAdmin: true,
    onlyAdmin: true
  },
  {
    path: '/:slug/integrations',
    exact: true,
    name: 'Integrations',
    component: Integrations,
    private: true,
    onlyCompanyAdmin: true,
    onlyAdmin: false
  },
  {
    path: '/:slug/solution',
    exact: true,
    name: 'CompanySolution',
    component: CompanySolution,
    private: true,
    onlyCompanyAdmin: true,
    onlyAdmin: false
  },
  {
    path: '/:slug/users',
    exact: true,
    name: 'CompanyUser',
    component: CompanyUser,
    private: true,
    onlyCompanyAdmin: true,
    onlyAdmin: false
  },
  {
    path: '/:slug/adduser',
    exact: true,
    name: 'AddUser',
    component: AddUser,
    private: true,
    onlyCompanyAdmin: true,
    onlyAdmin: false
  },
  {
    path: '/:slug/edituser',
    exact: true,
    name: 'AddUser',
    component: AddUser,
    private: true,
    onlyCompanyAdmin: true,
    onlyAdmin: false
  },
  {
    path: '/:slug/notifications',
    exact: true,
    name: 'Notification',
    component: Notification,
    private: true,
    onlyCompanyAdmin: true,
    onlyAdmin: false
  },

  {
    path: '/:slug/notifications/view',
    exact: true,
    name: 'Notification',
    component: ViewNotification,
    private: true,
    onlyCompanyAdmin: true,
    onlyAdmin: false
  },
  {
    path: '/:slug/change-password',
    exact: true,
    name: 'ChangePassword',
    component: ChangePassword,
    private: true,
    onlyCompanyAdmin: true,
    onlyAdmin: false
  },

  {
    path: '/:slug/sub-admins',
    exact: true,
    name: 'SubAdmin',
    component: SubAdmin,
    private: true,
    onlyCompanyAdmin: true,
    onlyAdmin: false
  },
  {
    path: '/:slug/sub-admins/add-edit',
    exact: true,
    name: 'AddEditSubAdmin',
    component: AddEditSubAdmin,
    private: true,
    onlyCompanyAdmin: true,
    onlyAdmin: false
  },
  // Survey Routes Starts From Here
  {
    path: '/surveys/my-survey',
    exact: false,
    name: 'MySurvey',
    component: MySurvey,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  {
    path: '/:slug/surveys/my-survey',
    exact: false,
    name: 'MySurvey',
    component: MySurvey,
    private: true,
    onlyCompanyAdmin: true,
    onlyAdmin: false
  },
  {
    path: '/surveys',
    exact: true,
    name: 'Survey Dashboard',
    component: SurveyDashboard,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  {
    path: '/:slug/surveys',
    exact: true,
    name: 'Survey Dashboard',
    component: SurveyDashboard,
    private: true,
    onlyCompanyAdmin: true,
    onlyAdmin: false
  },
  {
    path: '/surveys/summary/:surveyId',
    exact: false,
    name: 'Survey Summary',
    component: SurveyStatistics,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  {
    path: '/:slug/surveys/summary/:surveyId',
    exact: false,
    name: 'Survey Summary',
    component: SurveyStatistics,
    private: true,
    onlyCompanyAdmin: true,
    onlyAdmin: false
  },
  {
    path: '/surveys/add-edit',
    exact: false,
    name: 'Survey Add Edit',
    component: AddEditSurvey,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  {
    path: '/:slug/surveys/add-edit',
    exact: true,
    name: 'Survey Add Edit',
    component: AddEditSurvey,
    private: true,
    onlyCompanyAdmin: true,
    onlyAdmin: false
  },
  {
    path: '/surveys/preview',
    exact: false,
    name: 'Survey Preview',
    component: PreviewSurvey,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  {
    path: '/:slug/surveys/preview',
    exact: false,
    name: 'Survey Preview',
    component: PreviewSurvey,
    private: true,
    onlyCompanyAdmin: true,
    onlyAdmin: false
  },
  // Survey Routes Ends
  // Vision Ideas
  {
    path: '/content-management/vision-ideas',
    exact: true,
    name: 'VisionIdeas',
    component: VisionIdeas,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/content-management/vision-ideas/view',
    exact: true,
    name: 'ViewVisionIdeas',
    component: AddEditVisionIdeas,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/content-management/vision-ideas/add-edit',
    exact: true,
    name: 'AddEditVisionIdeas',
    component: AddEditVisionIdeas,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/peap-management',
    exact: true,
    name: 'specialistList',
    // component: UnderMaintenance,
    component: Specialist,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  {
    path: '/peap-management/invoice/:id',
    exact: true,
    name: 'Peap Invoice',
    // component: UnderMaintenance,
    component: PeapInvoice,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  {
    path: '/peap-dashboard',
    exact: true,
    name: "Dashboard",
    //  component: UnderMaintenance,
    // component: PeapDashboard,
    component: PeapManagement,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },

  {
    path: '/peap-B2B-wellPoints',
    exact: true,
    name: "B2B WellPoints",
    component: UnderMaintenance,
    // component: B2BWellPoints,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  {
    path: '/peap-B2B-wellPoints/view/:id',
    exact: true,
    name: 'Invoice Details',
    component: WellpointsInvoiceDetails,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  {
    path: '/peap-B2B-wellPoints/generate/invoice/:id',
    exact: true,
    name: 'Invoice Details',
    component: GenerateInvoice,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  {
    path: '/peap-management/profile/:userId',
    exact: true,
    name: 'peap-profile',
    component: MySpecialistProfile,
    // component: UnderMaintenance,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/pulse-survey',
    exact: true,
    name: 'pulse survey',
    component: PulseSurveyDashboard,
    // component: UnderMaintenance,

    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/pulse-survey/Mytemplatesviewall',
    exact: true,
    name: 'Mytemplatesviewall',
    component: Mytemplatesviewall,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/pulse-survey/my-survey',
    exact: false,
    name: 'MySurvey',
    component: MySurvey,
    private: true,
    onlyCompanyAdmin: true,
    onlyAdmin: false
  },
  {
    path: '/pulse-survey/myTemplatesDrafts',
    exact: true,
    name: 'myTemplatesDrafts',
    component: myTemplatesDrafts,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },

  {
    path: '/survey',
    exact: true,
    name: 'survey',
    component: SurveyStatistics,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/pulse-survey/add-edit-survey',
    exact: true,
    name: 'addEditSurvey',
    component: AddEditPulseSurvey,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  // shoorah admin can see this InsightsB2bSurvey, not in any use right now
  {
    path: '/pulse-survey/add-edit-survey/InsightsB2bSurvey',
    exact: true,
    name: 'InsightsB2bSurvey',
    component: InsightsB2bSurvey,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/preview/pulse-surveys',
    exact: false,
    name: 'Pulse Survey Preview',
    component: PreviewPulseSurveys,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },

  {
    path: '/survey-list',
    exact: false,
    name: 'MySurveyList',
    component: PulseSurvey,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  {
    path: '/self-assessment',
    exact: false,
    name: 'selfAssessmentDashboard',
    // component: UnderMaintenance,
    component: SelfAssessmentDashboard,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  {
    path: '/self-assessment/create-self-assessment',
    exact: false,
    name: 'createSelfAssessment',
    component: AddEditSelfAssessment,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  {
    path: '/self-assessment/view-all-assessment',
    exact: false,
    name: 'viewAllSelfAssessment',
    component: AllAssessment,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  {
    path: '/self-assessment/view-assessment',
    exact: false,
    name: 'viewSingleSelfAssessment',
    component: ViewAssessment,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  {
    path: '/tutorials',
    exact: false,
    name: 'tutorials',
    // component: UnderMaintenance,
    component: TutorialsPage,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  {
    path: '/tutorials/new',
    exact: false,
    name: 'tutorials',
    // component: UnderMaintenance,
    component: TutorialsEditViewPage,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  {
    path: '/tutorials/:tutorialId',
    exact: false,
    name: 'tutorials',
    // component: UnderMaintenance,
    component: TutorialsEditViewPage,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  {
    path: '*',
    exact: true,
    name: 'not-found',
    component: NotFound,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  }
];
export default routes;
